module.exports = __webpack_public_path__ + "img/25.c867d542.png";